import { KeyboardEvent, useRef, useState } from 'react'

import RoundedButton from 'components/Atoms/Buttons/RoundedButton/RoundedButton'
import Input from 'components/Atoms/Calculator/Input'
import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify'

interface ThirdStepParticularOtherProps {
  onCalculate: (days: number, time: number) => void
}

export default function ThirdStepParticularOther({
  onCalculate,
}: ThirdStepParticularOtherProps) {
  const { t } = useTranslation('calculator')

  const [daysInput, setDaysInput] = useState('')
  const [timeInput, setTimeInput] = useState('')

  // refs para mover el foco con Enter
  const daysRef = useRef<HTMLInputElement | null>(null)
  const timeRef = useRef<HTMLInputElement | null>(null)

  const handleCalculateClick = () => {
    const parsedDays = parseInt(daysInput, 10)
    const days = Number.isNaN(parsedDays) ? 0 : parsedDays

    const parsedTime = parseFloat(timeInput.replace(',', '.'))
    const time = Number.isNaN(parsedTime) ? 0 : parsedTime

    if (days <= 0 || time <= 0) {
      toast.error(t('calculator.rightColumn.errors.completeAllFields'), {
        theme: 'colored',
      })
      return
    }

    onCalculate(days, time)
  }

  const handleKeyDownDays = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      event.preventDefault()
      timeRef.current?.focus()
    }
  }

  const handleKeyDownTime = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      event.preventDefault()
      handleCalculateClick()
    }
  }

  return (
    <div className="h-full flex flex-col justify-end">
      <div className="h-full flex flex-col justify-between mt-6 sm:mt-24">
        <p>
          {t('calculator.rightColumn.thirdStep.particular.otherTransport.text')}
        </p>
        <div className="flex flex-row gap-4 max-sm:mb-6 max-sm:mt-6">
          <Input
            label={t(
              'calculator.rightColumn.thirdStep.particular.otherTransport.labelInput1',
            )}
            placeholder={t(
              'calculator.rightColumn.thirdStep.particular.otherTransport.placeholder1',
            )}
            className="w-48"
            value={daysInput}
            onChange={setDaysInput}
            onKeyDown={handleKeyDownDays}
            inputRef={daysRef}
          />
          <Input
            label={t(
              'calculator.rightColumn.thirdStep.particular.otherTransport.labelInput2',
            )}
            placeholder={t(
              'calculator.rightColumn.thirdStep.particular.otherTransport.placeholder2',
            )}
            className="w-48"
            value={timeInput}
            onChange={setTimeInput}
            onKeyDown={handleKeyDownTime}
            inputRef={timeRef}
          />
        </div>
        <RoundedButton onClick={handleCalculateClick}>
          {t('calculator.rightColumn.thirdStep.particular.otherTransport.cta')}
        </RoundedButton>
      </div>
    </div>
  )
}
